<template>
        <b-modal ref="modal" :title="title" @hide="onHide" @cancel="onCancel" :centered="true" :visible="open" :ok-title="okTitle" :hide-footer="hideFooterVal"
            :cancel-title="$t('general.cancel')" :size="size" @ok="saveModal" :ok-disabled="disabled" :static="true" scrollable > 
                <component ref="modalForm" :sendRequest="sendRequest" v-bind:is="renderModalForm"  :save="saveAct"
                    :data="modalProps" :saveState="saveState" :modalName="modalName" :modalEvent="modalEvent" :formName="form"
                    :onComplete="onComplete" :forms="forms[form]" :input="input" :changeVal="changeDisabled"></component>
        </b-modal>
</template>

<script>
    import i18n from '@/plugins/i18n';
    import WorkHoursCopy from './WorkHoursCopy'
    import Delete from './Delete'
    import SetState from './SetState'
    import Command from './Command'
    import Form from '@/components/Form'
    import Forms from '../forms'
    import UserCopy from './UserCopy.vue'
    import Camera from "@/components/Cameras"
    import jwt_decode from "jwt-decode";
    import {prepareRequestData, sendRequestList} from '@/assets/js/custom.js'

    export default {
        name: "Modals",
        data: function(){
            return{
                title: '',
                okTitle: i18n.t('general.save'),
                disabled: false,
                input: [],
                saveAct: false,
                size: 'lg',
                hideFooterVal: false,
                forms: Forms,
                tmpForm: this.form

            }
        },
        components:{
             Delete, SetState, WorkHoursCopy,UserCopy, Camera, Command, Form
        },
        props:{
            open: Boolean,
            modalEvent: Function,
            form: String,
            modalName: String,
            modalProps: Object,
            onComplete: Function,
        },
        computed:{
            loading(){
                return this.$store.getters.getAccountLoading
            },
            renderModalForm: function(){
                this.tmpForm = this.form
                this.hideFooterVal = false
                this.disabled = false
                this.input = []
                this.size = 'lg'
                this.title = i18n.t('general.'+this.modalName)
                this.okTitle = i18n.t('general.'+this.modalName)
                if(this.modalName === "delete") {
                    if(this.form == 'Account'){
                        this.disabled = true
                        this.input = ['account_info', 'account', 'account_no']
                    }
                    return "Delete"
                }else if(this.modalName === "SetState"){
                    if(this.modalProps && this.modalProps.type == 'usercopy'){
                        this.title = 'Kullanıcıyı Kopyala'
                        this.okTitle= 'Kullanıcıyı Kopyala'
                        return 'UserCopy'
                    }else{
                        this.title = this.modalProps && this.modalProps.name
                        this.okTitle= i18n.t('general.save')
                    }
                        return "SetState"
                }else if(this.modalName === "copy") {
                    return "WorkHoursCopy"
                }else if(this.modalName === "tolerance") {
                    this.form = 'WorkHoursTolerance'
                }else if( this.modalName === "createServiceForm"){
                        this.title = `${i18n.t('customer.list.serviceForm')}`
                        this.size ='xl'
                        this.hideFooterVal = true
                        return "createServiceForm"
                } else if(this.modalName === "camera"){
                    this.title = this.modalProps.name
                    this.hideFooterVal = true
                    this.size ='xl'
                    let params =  {
                        "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                        "uuid": this.modalProps.link_id,
                        "event" : "camera",
                    }
                    this.$socket.send(JSON.stringify(params))
                    return this.modalName
                }else if(this.modalName === "command"){
                    this.title = this.modalProps.cmd == 'ARM' ? 'Tam Kurma' : this.modalProps.cmd == 'STAYARM' ? ' Eviçi Kurma' : 'Çözme'
                    this.okTitle= 'Komut Gönder'
                    this.size ='md'
                    return this.modalName
                }
                if(this.form == 'PanelUserLDAP'){
                    this.size ='xl'
                }
                if(this.forms[this.form] ){
                    sendRequestList(this.forms[this.form], this)
                    return 'Form'
                }
              
            }
        },
        methods:{
            sendRequest: async function(){
                let data = {};
                if(this.$refs.modalForm.formData) 
                    data = prepareRequestData(this.forms[this.form], this.$refs.modalForm.formData )
                if(this.modalProps){
                    data.id = this.modalProps.id ? this.modalProps.id : this.modalProps.ID
                    data.type = this.modalProps.user_type !== null ? this.modalProps.user_type : undefined
                }
                data.parent_id = parseInt(this.$route.params.id)
                if(this.modalName == 'SetState'){
                    data[this.modalProps.type] = this.modalProps[this.modalProps.type]
                    await this.$store.dispatch((this.form+'_'+this.modalProps.type).toLowerCase(), data) 
                }else{
                    await this.$store.dispatch((this.form+'_'+this.modalName).toLowerCase(), data)
                }
                console.log(this.$store.getters.getAccountStatus)
                if(this.$store.getters.getAccountStatus.status == "Success"){
                    await this.$store.dispatch((this.form+'_get').toLowerCase(), data)
                    this.modalEvent(false)
                }
                this.saveState(false)
            },
            onHide: function(){
                if(!this.saveAct)
                    this.modalEvent(false)
                if(this.modalName == 'camera'){
                    console.log('Disconnect Camera')
                    let params =  {
                        "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                        "uuid": this.modalProps.link_id,
                        "event" : "disconnect_camera",
                    }
                    this.$socket.send(JSON.stringify(params))
                }
            },
            onCancel: function(){
                this.saveState(false)
                if(!this.saveAct)
                    this.modalEvent(false)
                if(this.modalName == 'camera'){
                    console.log('Disconnect Camera')
                    let params =  {
                        "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                        "uuid": this.modalProps.link_id,
                        "event" : "disconnect_camera",
                    }
                    this.$socket.send(JSON.stringify(params))
                }

            },
            saveState: function(val){
                this.saveAct = val
            },
            // Modal tamamlandığı zaman olacak event
            saveModal: async function(bvModalEvt){
                bvModalEvt.preventDefault()
                // Modalın içerisindeki watchı tetikler
                this.saveState(true)
            },
            changeData(val, name){
                this.modalProps[name] = val
            },
            changeDisabled(val){
                let tmpMP = this.modalProps
                this.input.map(i =>{
                    tmpMP = tmpMP[i]
                })
                console.log(val, tmpMP)
                if(val == tmpMP)
                    this.disabled = false
                else
                    this.disabled = true

            },
        },
        watch:{
            saveAct(){
                return false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/modals/index.vue